<template>
  <div :class="bem({displayStyle, unpadded})">
    <BaseHeading
      :class="bem('heading')"
    >
      <span :class="bem('heading', { 'highlight': true })">Prescription.</span> How it works.
    </BaseHeading>
    <ol :class="bem('steps')">
      <li
        v-for="(step, index) in steps"
        :key="index"
        :class="bem('step')"
      >
        <VisionIcon
          :id="'prescription-banner-' + step.icon"
          :icon="step.icon"
          gradient="default"
          size="small"
          :class="bem('icon')"
        />
        <div :class="bem('content-container')">
          <h3
            :class="bem('subheading')"
          >
            {{ step.heading }}
          </h3>
          <p :class="bem('content')">
            {{ step.content }}
          </p>
        </div>
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'PrescriptionBanner',

  props: {
    displayStyle: {
      type: String,
      default: 'grid',
      validator (value) {
        return ['grid', 'column', 'row'].includes(value)
      }
    },
    unpadded: { type: Boolean, value: false }
  },

  setup () {
    const bem = useBEM('PrescriptionBanner')
    return { bem }
  },

  data () {
    return {
      steps: [
        {
          icon: 'circle-check',
          heading: "1. Design your Prescription SunGods.",
          content: 'Choose your preferred SunGod model and colour combination.'
        },
        {
          icon: 'bag-add',
          heading: '2. Choose Prescription Lenses.',
          content: 'Choose from a choice of Standard or Thin lenses, with an optional Polarisation upgrade.'
        },
        {
          icon: 'upload-cloud',
          heading: '3. Upload your Prescription.',
          content: 'Either immediately after checkout, or later via a link in your email.'
        },
        {
          icon: 'package',
          heading: "4. Receive your Prescription SunGod's.",
          content: 'Delivered within four weeks of us receiving your prescription.'
        }
      ]
    }
  }
}
</script>

<style lang="postcss">
.PrescriptionBanner {
  @apply py-16;

  &--display-style-column {
    .PrescriptionBanner__steps {
      @apply grid-cols-1 mt-0 gap-0;
    }

    .PrescriptionBanner__content-container {
      @apply max-w-lg;
    }

    .PrescriptionBanner__step {
      @apply px-0;
    }
  }

  &--display-style-row {
    @apply w-full;

    .PrescriptionBanner__steps {
      @apply gap-sm
        md:gap-x-md md:grid-cols-2
        lg:grid-cols-4;
    }

    .PrescriptionBanner__content-container {
      @screen md {
        @apply max-w-none;
      }
    }
  }

  &--unpadded {
    .PrescriptionBanner__step {
      @apply p-0;
    }
  }
}

.PrescriptionBanner__heading  {
  @apply tracking-tight text-lg md:text-2xl;

  &--highlight {
    @apply text-grey-600;
  }
}

.PrescriptionBanner__steps {
  @apply grid gap-xs mt-[32px];

  @screen lg {
    @apply grid-cols-2 gap-sm mt-[62px];
  }
}

.PrescriptionBanner__step {
  @apply bg-white rounded-[10px] p-sm;
}

.PrescriptionBanner__content-container {
  @screen md {
    @apply max-w-[205px];
  }
}

.PrescriptionBanner__subheading {
  @apply heading-3 mt-xxs leading-normal;

  @screen md {
    @apply text-base mt-xs;
  }
}

.PrescriptionBanner__content {
  @apply text-black text-sm leading-normal font-medium mt-xxs;

  @screen md {
    @apply text-xxs;
  }
}
</style>
